import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosPublic from "../../api/axiosPublic";

export const verifyCustomApiLookup = createAsyncThunk(
  "verify/primary-kyc-customized-api-lookup-document",
  async (customerNumber, { rejectWithValue }) => {
    try {
      const { data } = await axiosPublic.get(
        `verify/primary-kyc-customized-api-lookup-document/${customerNumber}`
      );

      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
